import { formatVerbatimMoneyCurrency } from '@/shared/utils/formatMoneyDisplay';
import type { LeftToPay } from '../types/paymentLinks.types';

export type LeftToPayDisplay = { hidden: true } | { hidden: false; text: string };

export const LEFT_TO_PAY_PLACEHOLDER = '—';

export interface LeftToPayState {
    hasElemisReference: boolean;
    isLoading: boolean;
    isError: boolean;
    data: LeftToPay | undefined;
}

const shown = (text: string): LeftToPayDisplay => ({ hidden: false, text });

export function leftToPayDisplay({ hasElemisReference, isLoading, isError, data }: LeftToPayState): LeftToPayDisplay {
    if (!hasElemisReference) return { hidden: true };
    if (isLoading || isError || data === undefined) return shown(LEFT_TO_PAY_PLACEHOLDER);
    if (data.eligible) return shown(formatVerbatimMoneyCurrency(data.leftToPay));
    if (data.reason === 'no_elemis_agreement') return { hidden: true };
    if (data.reason === 'paid_in_full' && data.leftToPay !== null) return shown(formatVerbatimMoneyCurrency(data.leftToPay));
    return shown(LEFT_TO_PAY_PLACEHOLDER);
}
